import styled from 'styled-components';

export const RightSideColumns = styled.div`
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 10px;
`;
